// src/components/games/diceMatch/trinketTypes.ts

export type TrinketRarity = 'common' | 'uncommon' | 'rare' | 'epic' | 'legendary';
export type TrinketDuration = 'temporary' | 'permanent' | 'per-game';
export type TrinketEffectType =
  | 'extra_moves'
  | 'extra_dice'
  | 'reroll'
  | 'score_multiplier'
  | 'currency_multiplier'
  | 'guarantee_merge'
  | 'undo_move'
  | 'double_next_die'
  | 'wild_die'
  | 'sparkle_swap'
  | 'space_swap'
  | 'skip_die_level';

export interface TrinketTemplate {
  id: string;
  name: string;
  description: string;
  rarity: TrinketRarity;
  duration: TrinketDuration;
  effect_type: TrinketEffectType;
  effect_data: Record<string, any>;
  acquisition_methods: string[];
  cost_meta_currency: number | null;
  meta_cost: number; // Alias for cost_meta_currency
  drop_weight: number;
  is_premium_only: boolean;
  icon_emoji: string;
  icon: string; // Alias for icon_emoji
  is_active: boolean;
  created_at: string;
}

export interface UserTrinket {
  id: string;
  user_id: string;
  trinket_id: string;
  quantity: number;
  is_equipped: boolean;
  acquired_at: string;
  last_used_at: string | null;
  // Joined from template
  template?: TrinketTemplate;
}

export interface TrinketEffect {
  type: TrinketEffectType;
  data: Record<string, any>;
}

// Helper to get rarity color
export function getRarityColor(rarity: TrinketRarity): string {
  switch (rarity) {
    case 'common':
      return '#9e9e9e';
    case 'uncommon':
      return '#4caf50';
    case 'rare':
      return '#2196f3';
    case 'epic':
      return '#9c27b0';
    case 'legendary':
      return '#ff9800';
    default:
      return '#000000';
  }
}

// Helper to get rarity label
export function getRarityLabel(rarity: TrinketRarity): string {
  switch (rarity) {
    case 'common':
      return 'Common';
    case 'uncommon':
      return 'Uncommon';
    case 'rare':
      return 'Rare';
    case 'epic':
      return 'Epic';
    case 'legendary':
      return 'Legendary';
    default:
      return 'Unknown';
  }
}

// Helper to get duration label
export function getDurationLabel(duration: TrinketDuration): string {
  switch (duration) {
    case 'temporary':
      return 'One-Time Use';
    case 'permanent':
      return 'Permanent';
    case 'per-game':
      return 'Per Game';
    default:
      return 'Unknown';
  }
}
